import { render, staticRenderFns } from "./Desadvs.vue?vue&type=template&id=1e3d749b&"
import script from "./Desadvs.vue?vue&type=script&lang=js&"
export * from "./Desadvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports